import React from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const BasicCheckbox = React.memo(props => {
  const {
    name,
    value,
    checked,
    title,
    singleRow,
    disabled,
    onChange,
    renderLabel,
    controlFunc,
    labelStyles,
    checkboxStyles,
    wrapperStyles,
  } = props;

  const handleChange = event => {
    const { target } = event;

    if (onChange && typeof onChange === 'function') {
      onChange(name, value, target.checked);
    } else {
      controlFunc(event);
    }
  };

  return (
    <div
      className={`${
        singleRow
          ? 'basic-checkbox__wrapper basic-checkbox__wrapper--single-row'
          : 'basic-checkbox__wrapper'
      }${disabled ? ' basic-checkbox__wrapper--disabled' : ''}`}
      style={wrapperStyles}
    >
      <label className="basic-checkbox__label" style={labelStyles}>
        <input
          className="basic-checkbox"
          disabled={disabled}
          name={name}
          onChange={handleChange}
          value={value}
          checked={checked}
          type="checkbox"
        />
        <span className="basic-checkbox__checkmark" style={checkboxStyles} />

        {title ? (
          <span className="basic-checkbox__text">{title}</span>
        ) : (
          <span className="basic-checkbox__text">{renderLabel}</span>
        )}
      </label>
    </div>
  );
});

BasicCheckbox.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number,
  ]).isRequired,
  title: PropTypes.string,
  disabled: PropTypes.bool,
  name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  checked: PropTypes.bool,
  controlFunc: PropTypes.func,
  onChange: PropTypes.func,
  singleRow: PropTypes.bool,
  labelStyles: PropTypes.object,
  checkboxStyles: PropTypes.object,
  wrapperStyles: PropTypes.object,
  renderLabel: PropTypes.object,
};

export default BasicCheckbox;
